import { render, staticRenderFns } from "./CompaniesCreateEdit.vue?vue&type=template&id=183e64f2&"
import script from "./CompaniesCreateEdit.vue?vue&type=script&lang=js&"
export * from "./CompaniesCreateEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports